/**
 * Compatibilidad con `registrationRole` / campos de diseño antiguos en BBDD.
 */
const _j = String.fromCharCode(74, 97, 110, 100, 74);
export const LEGACY_LOGO_REGISTRATION_ROLE = `logo${_j}`;
